import { FC, Fragment, useState } from 'react';
import { Grid, Text } from '@hopskipdrive/react-components';
import { truncate } from 'lodash';

import { formatDate, formattedIsoDate } from '../../../utils/helpers';

import { StyledGrid, StyledSpan } from './styles';

interface CalendarBreakDetailsProps {
  calendar: Nullable<Calendar>;
}

export const RideCalendarBreakDetails: FC<CalendarBreakDetailsProps> = ({ calendar }) => {
  const [isCalendarDetailsOpen, setIsCalendarDetailsOpen] = useState(false);
  const moreDetailsText = isCalendarDetailsOpen ? 'Hide Details' : 'More Details';

  function formattedDetailRowHeader(calendarDetails: Calendar) {
    const { breaks } = calendarDetails;
    const scheduleModifications: string[] = [];
    const PREVIEW_ROW_LIMIT = 2;
    const remainder = breaks.length - PREVIEW_ROW_LIMIT;

    breaks
      .slice(0, PREVIEW_ROW_LIMIT)
      .forEach((elem: Break) => scheduleModifications.push(formattedDateRange(elem.startDate, elem.endDate)));

    let detailRow = `Days off: ${scheduleModifications.join(', ')}`;

    if (remainder >= PREVIEW_ROW_LIMIT) {
      detailRow = truncate(detailRow, { length: 60 }).concat(` and ${remainder} more`);
    }

    return detailRow;
  }

  function formattedDateRange(startDate: string, endDate: string) {
    return `${formatDate(formattedIsoDate(startDate), 'MM/dd/yyyy')}${
      startDate !== endDate ? `-${formatDate(formattedIsoDate(endDate), 'MM/dd/yyyy')}` : ''
    }`;
  }

  function formattedDetailRow(calendarBreak: Break) {
    return (
      <>
        <Grid item xs={3}>
          {formattedDateRange(calendarBreak.startDate, calendarBreak.endDate)}
        </Grid>
        <Grid item xs={9}>
          {calendarBreak.description}
        </Grid>
      </>
    );
  }

  return (
    <>
      {calendar && (
        <StyledGrid item xs={12}>
          <Text>{calendar.name}</Text>
          {formattedDetailRowHeader(calendar)}{' '}
          {calendar.breaks.length > 0 && (
            <StyledSpan onClick={() => setIsCalendarDetailsOpen(!isCalendarDetailsOpen)}>{moreDetailsText}</StyledSpan>
          )}
          <Grid container>
            {isCalendarDetailsOpen &&
              calendar.breaks?.map((calendarBreak) => (
                <Fragment key={calendarBreak.slug}>{formattedDetailRow(calendarBreak)}</Fragment>
              ))}
          </Grid>
        </StyledGrid>
      )}
    </>
  );
};
